import React, { useState, useEffect, useCallback } from 'react';
import CleaningLogin from './CleaningLogin';
import CleaningDashboard from './CleaningDashboard';

const API = process.env.REACT_APP_BACKEND_URL || '';

const CleaningPortal = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = sessionStorage.getItem('cleaning_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await fetch(`${API}/api/cleaning/auth/me`, {
        headers: { 'Authorization': `Bearer ${token}` },
        credentials: 'include',
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data);
      } else {
        sessionStorage.removeItem('cleaning_token');
      }
    } catch {
      sessionStorage.removeItem('cleaning_token');
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const handleLogin = (userData) => setUser(userData);

  const handleLogout = () => {
    sessionStorage.removeItem('cleaning_token');
    setUser(null);
    fetch(`${API}/api/cleaning/auth/logout`, { method: 'POST', credentials: 'include' });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F7F9F9] flex items-center justify-center">
        <div className="w-8 h-8 border-3 border-[#65c3ba] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <CleaningLogin onLogin={handleLogin} />;
  return <CleaningDashboard user={user} onLogout={handleLogout} />;
};

export default CleaningPortal;
